import requests from "@/api/request";
import { RootState } from "@/store/types";
import _ from "lodash";
import { ActionTree } from "vuex";
import { Patient } from "../patient/types";
import { User } from "../user/types";
import {
  TOWER_ALERT_REVIEW_LOAD,
  TOWER_ALERT_REVIEW_UPDATE,
  TOWER_POSTOPREVIEW_SAVE,
  TOWER_REVIEW_SAVE
} from "./mutation_types";
import { TowerState } from "./types";

export const enum TowerAction {
  LOAD = "load",
  SAVE_NOTE = "saveNote",
  SAVE = "save",
  ENTRY = "Entry",
  EDIT_CASE_REVIEW = "editCaseReview",
  SAVE_CASE_REVIEW = "saveCaseReview",
  SAVE_POSTOP_REVIEW = "savePostOpReview"
}

export const actions: ActionTree<TowerState, RootState> = {
  // LOAD
  async [TOWER_ALERT_REVIEW_LOAD](
    { commit },
    formData: { opSys: string; roomSys: string }
  ): Promise<void> {
    const data = await requests.towerRequest(formData, TowerAction.LOAD);
    commit(TOWER_ALERT_REVIEW_LOAD, data);
  },
  // UPDATE / SAVE
  async [TOWER_ALERT_REVIEW_UPDATE](
    { commit, rootGetters },
    { item, type }: { item: any; type: TowerAction }
  ): Promise<void> {
    type = type || TowerAction.SAVE;

    const formData: Record<string, any> = Object.assign({}, item);

    // Avoid sending html characters to server
    formData.message = escape(formData.message);
    if (!_.isFinite(formData.sequence)) {
      formData.sequence = 1;
    } else {
      if (formData.incrementSequence) {
        formData.sequence++;
      }
    }

    const user = rootGetters["user/user"] as User;
    const patient = rootGetters["patient/current"] as Patient;
    formData.userID = user.userID;
    formData.roomSys = patient.census.roomSys;
    const result = await requests.towerRequest(formData, type);
    commit(TOWER_ALERT_REVIEW_LOAD, result.review);
    commit("patient/bodyUpdate", result.caseInfo, { root: true });
    commit(
      "patient/now",
      {
        now: result.caseInfo.body.now,
        dateTimeOffset: result.caseInfo.body.dateTimeOffset
      },
      { root: true }
    );
  },
  // REVIEW SAVE
  async [TOWER_REVIEW_SAVE](
    { rootGetters },
    {
      item,
      action,
      roomSys
    }: { item: any; action: TowerAction; roomSys: string }
  ): Promise<void> {
    const formData: Record<string, any> = Object.assign({}, item);
    const user = rootGetters["user/user"] as User;
    formData.userID = user.userID;
    formData.roomSys = roomSys;
    return await requests.towerRequest(formData, action);
  },

  // POSTOPREVIEW SAVE
  async [TOWER_POSTOPREVIEW_SAVE](
    { rootGetters },
    {
      item,
      action,
      roomSys
    }: { item: any; action: TowerAction; roomSys: string }
  ): Promise<void> {
    // .map out the fields we actually need to send...
    const formData: Record<string, any> = Object.assign(
      {},
      { postOpReview: JSON.stringify(item) }
    );
    const user = rootGetters["user/user"] as User;
    formData.userID = user.userID;
    formData.roomSys = roomSys;
    formData.area = rootGetters["patient/area"];
    return await requests.towerRequest(formData, action);
  }
};
